import { render, staticRenderFns } from "./BonusEditor.vue?vue&type=template&id=1b4fcdbc&scoped=true&"
import script from "./BonusEditor.vue?vue&type=script&lang=js&"
export * from "./BonusEditor.vue?vue&type=script&lang=js&"
import style0 from "./BonusEditor.vue?vue&type=style&index=0&id=1b4fcdbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4fcdbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
